<div mat-dialog-title>
  <h2>Move</h2>
  <button mat-icon-button title="Close Dialog" class="mat-dialog-title__close" data-testid="move-bulk-close-button" (click)="onClose()">
    <fa-icon [icon]="faClose"></fa-icon>
  </button>
</div>
<mat-dialog-content id="jumpToPositionContainer" class="move-bulk-to-position__content">
  <div class="move-bulk-to-position__content__moving">
    <div class="move-bulk-to-position__content__moving__list">
      <span class="fs__md fw__600">
        Moving
        @if (questionsToMove.length > 1) {
          ({{ questionsToMove.length }})
        }
      </span>

      @for (questionToMove of questionsToMove; track questionToMove.id) {
        <div class="move-bulk-to-position__content__moving__list__item">
          <fa-icon [icon]="questionTypeConfig[questionToMove.type].icon"></fa-icon>
          <span>{{ questionToMove.code }}. {{ questionToMove.title | toPlainText }}</span>
        </div>
      }
    </div>

    @if (data?.affectedElements) {
      <div class="move-bulk-to-position__content__moving__warning">
        <div class="move-bulk-to-position__content__moving__warning__icon">
          <fa-icon [icon]="faCircleExclamation"></fa-icon>
        </div>
        <span class="fs__sm fw__400">Moving this question may affect the conditional logic in your survey. Please check and update as needed.</span>
      </div>
    }
  </div>

  <div class="move-bulk-to-position__content__list">
    <ng-template
      #insertCard
      let-label="label"
      let-index="index"
      let-last="last"
      let-selected="selected"
      let-moveIntoBlock="moveIntoBlock"
      let-blockSelected="blockSelected"
      let-isBlockBeginning="isBlockBeginning"
      let-isBlockEnd="isBlockEnd"
    >
      <div
        class="move-bulk-to-position__content__list__insert"
        [class.selected]="selected"
        [attr.data-testid]="'move-bulk-insert-position-' + index"
        (click)="onSelectPosition(index, last, moveIntoBlock, blockSelected, isBlockBeginning, isBlockEnd)"
      >
        <fa-icon [icon]="faPlus"></fa-icon>
        <span class="fs__sm fw__500">{{ label }}</span>
      </div>
    </ng-template>

    @for (questionData of questionsWithBlocks; track questionData.question.id) {
      @if (
        !questionData.isInsideMultiBlock ||
        (questionData.isInsideMultiBlock && (questionData.isFirstBlockInsideMultiBlock || !questionData.isFirstElementInBlock)) ||
        (!questionData.isInsideMultiBlock && !!questionData.block)
      ) {
        @if ($index === 0) {
          <ng-container
            *ngTemplateOutlet="
              insertCard;
              context: {
                label: 'Insert at beginning',
                index: $index,
                last: false,
                selected: selectedPosition$() === $index && !isBlockBeginning$() && !isBlockEnd$(),
                moveIntoBlock: !!questionData.block && !questionData.isFirstElementInBlock,
                blockSelected: questionData.block,
                isBlockBeginning: false,
                isBlockEnd: false
              }
            "
          ></ng-container>
        } @else if (
          (!data.questionsToMoveIds.includes(questionData.question.id) && !isDisallowedInsertHere($index)) ||
          (questionData.isFirstElementInBlock && data.questionsToMoveIds.includes(questionData.question.id))
        ) {
          <ng-container
            *ngTemplateOutlet="
              insertCard;
              context: {
                label: 'Insert here',
                index: $index,
                last: false,
                selected: selectedPosition$() === $index && !isBlockBeginning$() && !isBlockEnd$(),
                moveIntoBlock: !!questionData.block && !questionData.isFirstElementInBlock,
                blockSelected: questionData.block,
                isBlockBeginning: false,
                isBlockEnd: false
              }
            "
          ></ng-container>
        }
      }
      @if (questionData.isFirstElementInBlock) {
        <ng-container
          *ngTemplateOutlet="
            insertCard;
            context: {
              label: 'Insert at beginning of block ' + questionData.block.id,
              index: $index,
              last: false,
              selected: selectedPosition$() === $index && moveIntoBlock$() && isBlockBeginning$(),
              moveIntoBlock: true,
              blockSelected: questionData.block,
              isBlockBeginning: true,
              isBlockEnd: false
            }
          "
        ></ng-container>
      }

      <div class="move-bulk-to-position__content__list__card" [class.current]="data.questionsToMoveIds.includes(questionData.question.id)">
        <div class="move-bulk-to-position__content__list__card__icon">
          <fa-icon [icon]="questionTypeConfig[questionData.question.type].icon"></fa-icon>
        </div>
        <div class="move-bulk-to-position__content__list__card__info">
          <span class="fs__sm fw__500">{{ questionData.question.code }}. {{ questionData.question.title | toPlainText }}</span>
          <span class="fs__xs fw__400">{{ questionTypeLabels[questionData.question.type] }}</span>
        </div>
        @if (data.questionsToMoveIds.includes(questionData.question.id)) {
          <div class="move-bulk-to-position__content__list__card__badge">
            <eiq-badge [color]="'primary'" [text]="'Current'"></eiq-badge>
          </div>
        }
      </div>

      @if (questionData.isLastElementInBlock) {
        <ng-container
          *ngTemplateOutlet="
            insertCard;
            context: {
              label: 'Insert at end of block ' + questionData.block.id,
              index: $index,
              last: false,
              selected: selectedPosition$() === $index && moveIntoBlock$() && isBlockEnd$(),
              moveIntoBlock: true,
              blockSelected: questionData.block,
              isBlockBeginning: false,
              isBlockEnd: true
            }
          "
        ></ng-container>
      }
      @if ($last) {
        <ng-container
          *ngTemplateOutlet="
            insertCard;
            context: {
              label: 'Insert at end',
              index: $index,
              last: true,
              selected: selectedPosition$() === questionsWithBlocks.length,
              moveIntoBlock: false,
              blockSelected: null,
              isBlockBeginning: false,
              isBlockEnd: false
            }
          "
        ></ng-container>
      }
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions class="move-bulk-to-position__actions">
  @if (questionsToMove.length > 1) {
    <div class="move-bulk-to-position__actions__info">
      <fa-icon [icon]="faInfoCircle"></fa-icon>
      <span class="fs__sm fw__500">Moving keeps the selected questions together and preserves their order and logic.</span>
    </div>
  }
  @if (anyBlocker$()) {
    <div class="move-bulk-to-position__actions__blocker">
      <fa-icon [icon]="faCircleExclamation"></fa-icon>
      @for (warning of warnings$(); track $index) {
        @if (warning.blockerInd) {
          <span class="fs__sm fw__500" [innerHTML]="warning.message"></span>
        }
      }
    </div>
  }
  <div>
    <button mat-stroked-button data-testid="move-bulk-cancel-button" (click)="onClose()">Cancel</button>
    <button
      mat-flat-button
      [color]="'primary'"
      data-testid="move-bulk-confirm-button"
      [disabled]="selectedPosition$() === null || anyBlocker$()"
      (click)="onMove()"
    >
      Confirm
    </button>
  </div>
</mat-dialog-actions>
